import { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Button } from './Button';

export type UndoState = {
  ids: string[];
  message: string;
};

type Props = {
  undo: UndoState | null;
  onUndo: () => void;
  onDismiss: () => void;
};

export const NotificationUndoSnackbar = ({ undo, onUndo, onDismiss }: Props) => {
  useEffect(() => {
    if (!undo) return;
    const timer = window.setTimeout(onDismiss, 4_000);
    return () => window.clearTimeout(timer);
  }, [onDismiss, undo]);

  return (
    <AnimatePresence>
      {undo ? (
        <motion.div className="notificationUndoSnackbar" initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 20, opacity: 0 }}>
          <span>{undo.message}</span>
          <Button variant="tertiary" size="sm" onClick={onUndo}>
            Undo
          </Button>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
